import { TEMPLATE_ID } from "./constants";

export const getOverallRanking = (fansUnitedSDK, groupId = undefined, filters = {}) => {
	const defaultFilters = { limit: 20, page: 1, ...filters };
	if (groupId) {
		defaultFilters.groupId = groupId;
	}
	return fansUnitedSDK.loyalty.getLeaderboard(TEMPLATE_ID, defaultFilters, true);
};

export const getMyRanking = (fansUnitedSDK) => {
	return fansUnitedSDK.loyalty.getOwnRankings({
		leaderboardIds: [TEMPLATE_ID],
	});
};

export const getMyWeeklyRanking = async (fansUnitedSDK, groupId, userId) => {
	try {
		// Get the weekly leaderboard data and find the user in it
		const leaderboardResponse = await getRoundRanking(fansUnitedSDK, groupId, {
			limit: 1000, // Get more results to find the user
			page: 1,
		});

		if (!leaderboardResponse.data || leaderboardResponse.data.length === 0) {
			return { data: [] };
		}

		// Find the current user in the leaderboard data
		const userEntry = leaderboardResponse.data.find((entry) => entry.profileId === userId || entry.profileModel?.id === userId);

		if (userEntry) {
			// Format the response to match the expected structure
			const formattedResponse = {
				data: [
					{
						id: TEMPLATE_ID,
						position: userEntry.position,
						points: userEntry.points,
						profileId: userEntry.profileId,
						profileModel: userEntry.profileModel,
					},
				],
			};
			return formattedResponse;
		} else {
			return { data: [] };
		}
	} catch (error) {
		throw error;
	}
};

export const getRoundRanking = (fansUnitedSDK, groupId, filters = {}) => {
	const defaultFilters = {
		groupId: groupId,
		limit: 20,
		page: 1,
		...filters,
	};
	return fansUnitedSDK.loyalty.getLeaderboard(TEMPLATE_ID, defaultFilters, true);
};

/**
 * Get current points based on user predictions, filtered by matches and markets
 * @param {Array} userPredictions - Array of user predictions
 * @param {Array} matches - Array of current matches
 * @param {Array} availableMarkets - Array of available markets
 * @returns {number} Total current points for filtered predictions
 */
export const getMyCurrentPoints = (userPredictions, matches, availableMarkets) => {
	if (!userPredictions || !Array.isArray(userPredictions)) {
		return 0;
	}

	// Get match IDs and market types for filtering
	const matchIds = matches?.map((match) => match.id) || [];
	const marketTypes = availableMarkets?.map((market) => market.type) || [];

	// Filter predictions that match current matches and available markets
	const filteredPredictions = userPredictions.filter((prediction) => {
		const matchExists = matchIds.length === 0 || matchIds.includes(prediction.matchId);
		const marketExists = marketTypes.length === 0 || marketTypes.includes(prediction.market);
		return matchExists && marketExists;
	});

	// Sum up the points from filtered predictions
	return filteredPredictions.reduce((total, prediction) => {
		return total + (prediction.result?.points || 0);
	}, 0);
};
